'use client';

import {
    LocalImage,
    type LocalImageProps,
} from '@/components/atoms/LocalImage';
import { P } from '@/components/atoms/Typography/P';

export interface ListItemProps {
    id: string | number;
    description: string;
    image: LocalImageProps;
}

export default function ListItem({ description, image }: ListItemProps) {
    return (
        // Added width to looking alike production
        <div className="mx-auto my-0 flex max-w-[320px] flex-col items-center pb-8 min-[560px]:w-full md:p-0">
            <LocalImage
                className="mb-4 max-h-[128px]"
                width={128}
                height={128}
                {...image}
            />

            <P
                className="mb-2 text-center"
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </div>
    );
}
